import React, { useState, useEffect} from 'react';
import {HorizontalBar} from 'react-chartjs-2';


export default function HorzintalBarScoreRow(props){

      const [optionId, setOptionId] = useState(null);
      const [dataTemplate, setDataTemplate] = useState({});

      useEffect(()=>{
        try {console.log("refreshing pie graph");
        console.log(props.scores);
        if(!props.scores || !props.option){
          return ;
        }
        let dataSets = props.nodes.map( node =>
          ({
              label: node.title,
              data: [],
              backgroundColor: node.hex_color?(node.hex_color ):"rgba(225, 58, 55, 0.7)",
              hoverBackgroundColor: node.hex_color?(node.hex_color ):"rgba(225, 58, 55, 0.7)",
              hoverBorderWidth: 2,
              hoverBorderColor: 'lightgrey'
          })
        )
        let labels = [];
        labels.push(props.option.title);
        dataSets.map(dataSet => {
          dataSet.data.push(props.scores[dataSet.label].normalize)
        })
        console.log("data tamp");
        console.log({
                  labels: labels,
                  datasets: dataSets,
              });
        setDataTemplate({
                  labels: labels,
                  datasets: dataSets,
              });
        }
        catch(e){
          console.log("data tamp error");
          console.log(e);
        }
      }, [props.option, props.scores])

      const pieOptions = {
        legend: {
          display: false,
          position: "right",
        },

        }
      return (<div className="options-graph-bar">
                  <HorizontalBar
                    data={dataTemplate}
                    height={30}
                    options={pieOptions}
                    borderColor="black"
                    options={{tooltips: {
                                   enabled: false
                              },
                              scales: {
                                yAxes : [{
                                  gridLines: { lineWidth:0,display:false, drawBorder: false},
                                  stacked: true,
                                  ticks : {
                                    display: false,

                                  },
                                scaleLabel: {
                                  display: false,
                                }}],
                                xAxes : [{
                                  gridLines: { lineWidth:0,display:false, drawBorder: false},
                                  stacked: true,
                                  ticks : {
                                    max : 100,
                                    min : 0,
                                    display: false,
                                  },
                                }]
                              },
                              legend: { display: false },
                          }}
                  />
          </div>)
}
